import React, { useContext } from "react";
import { CookieContext } from "../../context/CookieContext";
import { Link } from "react-router-dom";

const CookieConsent = () => {
  const { showBanner, acceptCookies, rejectCookies } =
    useContext(CookieContext);

  if (!showBanner) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 bg-brand-charcoal text-brand-cream p-4 z-50 animate-slide-up"
      style={{ transition: "all 0.3s" }}
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent banner"
    >
      <div className="max-w-2xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4 relative">
        {/* Close (X) button for mobile and accessibility */}
        <button
          onClick={() => acceptCookies(false)}
          className="absolute top-2 right-2 text-brand-muted hover:text-brand-cream text-xl md:hidden focus:outline-none"
          aria-label="Close cookie consent banner (accept necessary only)"
        >
          &times;
        </button>
        <div className="flex-1 text-sm md:text-base pr-8 md:pr-0">
          <span className="hidden md:inline">
            We use cookies to enhance your experience and analyze our traffic.{" "}
            <Link
              to="/privacy-policy"
              className="text-brand-gold underline hover:text-brand-gold/80"
            >
              Learn more
            </Link>
            .
          </span>
          <span className="md:hidden">
            We use cookies.{" "}
            <Link
              to="/privacy-policy"
              className="text-brand-gold underline hover:text-brand-gold/80"
            >
              Details
            </Link>
            .
          </span>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 mt-2 md:mt-0">
          <button
            onClick={() => acceptCookies(true)}
            className="px-4 py-2 rounded-lg bg-brand-gold text-brand-charcoal font-display font-bold tracking-wide hover:bg-brand-gold/90 focus:outline-none focus:ring-2 focus:ring-brand-gold"
            aria-label="Accept all cookies"
          >
            Accept All
          </button>
          <button
            onClick={() => acceptCookies(false)}
            className="px-4 py-2 rounded-lg border border-brand-cream/40 text-brand-cream hover:bg-brand-charcoal focus:outline-none"
            aria-label="Accept necessary cookies only"
          >
            Necessary Only
          </button>
          <button
            onClick={rejectCookies}
            className="px-4 py-2 rounded-lg border border-brand-cream/40 text-brand-cream hover:bg-brand-charcoal focus:outline-none"
            aria-label="Reject all cookies"
          >
            Reject All
          </button>
        </div>
      </div>
      {/* Animation keyframes (inline for demo, move to CSS for production) */}
      <style>{`
        @keyframes slide-up {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        .animate-slide-up {
          animation: slide-up 0.4s cubic-bezier(0.4,0,0.2,1);
        }
      `}</style>
    </div>
  );
};

export default CookieConsent;
